import { createFileRoute } from "@tanstack/react-router";

import ChatbotIds from "../pages/ChatbotIds";
import { RequireAuth } from "../utils/RequireAuth";

// App.jsx folded the admin check into ProtectedRoute's isAuthenticated, which
// sent authenticated non-admins to /login. RequireAuth require="admin" sends
// them to "/" instead — an intentional fix of that /login bounce.
export const Route = createFileRoute("/_shell/chatbot-ids")({
  component: ChatbotIdsRoute,
});

function ChatbotIdsRoute() {
  return (
    <RequireAuth require="admin">
      <ChatbotIds />
    </RequireAuth>
  );
}
